import { useEffect, useRef } from 'react';

export function useCrossTabChannel(channelName: string, onMessage: (msg: any) => void) {
  const channelRef = useRef<BroadcastChannel | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !('BroadcastChannel' in window)) {
      throw new Error('BroadcastChannel is not supported in this environment');
    }

    const channel = new window.BroadcastChannel(channelName);
    channelRef.current = channel;

    channel.onmessage = (e: any) => onMessage(e.data);

    return () => {
      channel.close();
      if (channelRef.current === channel) {
        channelRef.current = null;
      }
    };
  }, [channelName, onMessage]);

  const sendMessage = (msg: any) => {
    const channel = channelRef.current;
    if (!channel) return;

    try {
      channel.postMessage(msg);
    } catch (error: any) {
      if (error?.name === 'InvalidStateError') {
        channelRef.current = null;
        return;
      }
      throw error;
    }
  };

  return { sendMessage };
}
